export default __webpack_public_path__ + "a81361ebd8463d72b9b277c6eed0044c.png";